var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#50AF95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4415 8.57025V10.3448C16.7362 10.497 19.212 11.1503 19.212 11.9325C19.212 12.7148 16.7362 13.368 13.4415 13.5195V19.2075H10.5068V13.521C7.20675 13.3688 4.725 12.7155 4.725 11.9325C4.725 11.1495 7.20675 10.4955 10.5068 10.344V8.57025H6.44625V5.86425H17.502V8.57025H13.4415ZM13.4415 13.0357V13.0373C16.3515 12.9083 18.5227 12.402 18.5227 11.7945C18.5227 11.1885 16.3515 10.6807 13.4415 10.551V12.5332C13.3568 12.5408 12.903 12.5782 11.9978 12.5782C11.2433 12.5782 10.6973 12.546 10.5068 12.5325V10.5495C7.59075 10.68 5.41425 11.1877 5.41425 11.7945C5.41425 12.402 7.59075 12.9097 10.5068 13.038V13.0357C10.6943 13.0448 11.2275 13.0673 11.985 13.0673C12.9338 13.0673 13.359 13.0417 13.4415 13.0357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.974519fdb03e4ff479a5d273f5ff808b.svg";
export { ForwardRef as ReactComponent };